import { Link } from 'react-router-dom'
import type { Dashboard } from '../types'

interface DashboardCardProps {
  dashboard: Dashboard
}

export default function DashboardCard({ dashboard }: Readonly<DashboardCardProps>) {
  return (
    <Link
      to={`/dashboard/${dashboard.id}`}
      className="group block rounded-2xl bg-cbc-dark-blue/40 backdrop-blur-xl shadow-cbc-dark hover:shadow-cbc-lg border border-cbc-medium-blue/18 hover:border-cbc-primary/40 overflow-hidden transition-all duration-300 hover:-translate-y-1"
    >
      {/* Gradient header with decorative elements */}
      <div className="relative bg-gradient-to-br from-cbc-navy via-cbc-dark-blue to-cbc-primary p-6 overflow-hidden">
        {/* Growing circle on hover */}
        <div className="absolute -right-6 -top-6 w-28 h-28 bg-cbc-light-blue/10 rounded-full transition-transform duration-500 group-hover:scale-150" />
        <div className="absolute right-4 bottom-1 w-10 h-10 bg-cbc-primary/25 rounded-full blur-md" />
        {/* Decorative mini chart bars */}
        <div className="absolute bottom-3 left-5 flex items-end space-x-1 opacity-20 group-hover:opacity-35 transition-opacity duration-300">
          {[35, 55, 40, 75, 50, 85, 65].map((h) => (
            <div key={h} className="w-1.5 bg-cbc-paper rounded-sm" style={{ height: `${h * 0.28}px` }} />
          ))}
        </div>
        <div className="relative z-10 flex justify-center">
          <svg className="w-11 h-11 text-white/90" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
      </div>

      {/* Body */}
      <div className="p-5 bg-gradient-to-b from-cbc-paper/[0.03] to-transparent">
        <h3 className="text-base font-bold text-cbc-paper mb-1.5 group-hover:text-cbc-light-blue transition-colors duration-200">
          {dashboard.name}
        </h3>
        <p className="text-sm text-cbc-light-blue/72 mb-4 leading-relaxed">{dashboard.description}</p>
        <div className="flex items-center justify-between">
          {dashboard.category && (
            <span className="inline-flex items-center px-2.5 py-0.5 text-xs font-semibold text-cbc-light-blue bg-cbc-light-blue/10 border border-cbc-light-blue/15 rounded-full">
              {dashboard.category}
            </span>
          )}
          <span className="ml-auto flex items-center text-xs font-semibold text-cbc-medium-blue group-hover:text-cbc-paper group-hover:translate-x-0.5 transition-all duration-200">
            Ver dashboard
            <svg className="w-3.5 h-3.5 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </span>
        </div>
      </div>
    </Link>
  )
}
